import { Box, BoxProps, chakra } from '@chakra-ui/react'
import React from 'react'

interface InlineDividerProps {
  size?: number | string
}
export const InlineDivider = ({ size = 20 }: InlineDividerProps) => {
  const sizePx = typeof size === 'number' ? `${4 * size}px` : size
  return (
    <chakra.span
      bgColor="neutral.20"
      display="inline-block"
      h={sizePx}
      m={`0 ${sizePx}`}
      w="1px"
    />
  )
}

interface HorizontalDivider extends BoxProps {
  outside?: number | string
}
export const HorizontalDivider: React.FC<HorizontalDivider> = ({
  outside = 0,
  ...props
}) => {
  const marginPx = typeof outside === 'number' ? `${4 * outside}px` : outside
  return (
    <Box
      as="hr"
      bgColor="neutral.20"
      gridColumn="1 / -1"
      mx={outside ? `-${marginPx}` : 0}
      my={5}
      {...props}
    />
  )
}
